import { render, staticRenderFns } from "./PlayerDiplomaticStatusIcon.vue?vue&type=template&id=22744d27&scoped=true&"
import script from "./PlayerDiplomaticStatusIcon.vue?vue&type=script&lang=js&"
export * from "./PlayerDiplomaticStatusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22744d27",
  null
  
)

export default component.exports